import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LogoRFID from '../Imagenes/Logo animado.gif';
import {
    MDBContainer,
    MDBInput,
    MDBBtn
} from 'mdb-react-ui-kit';

const Login = ({ setIsLoggedIn }) => {
    const [rut, setRut] = useState('');
    const [clave, setClave] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRutChange = (e) => {
        setRut(e.target.value);
    };

    const handleClaveChange = (e) => {
        setClave(e.target.value);
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        console.log('Datos enviados:', { rut, clave });

        try {
            const response = await axios.post('https://invio.datachile.site/Web/Login/IniciarSession.php', { rut, clave });

            if (response.status === 200 && response.data.usuario) {
                localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
                setIsLoggedIn(true);
                setError('');
                console.log('Datos del usuario almacenados en localStorage:', response.data.usuario);
                navigate('/dashboard');
            } else {
                setError('Error en la solicitud');
                console.log('Error en la solicitud:', response);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setError('Credenciales inválidas');
                alert('Credenciales inválidas');
                console.log('Credenciales inválidas:', error.response);
            } else {
                setError('Error en la solicitud HTTP');
                console.log('Error en la solicitud HTTP:', error);
            }
        }
    };

    return (
        <MDBContainer className="p-3 my-5 d-flex flex-column w-50">
            <div className="text-center mb-4" style={{ paddingBottom: "20px" }}>
                <img src={LogoRFID} style={{ width: '70%' }} alt="logo" />
            </div>

            <MDBInput wrapperClass='mb-4' label='Rut o Usuario' id='form1' value={rut} onChange={handleRutChange} />
            <MDBInput wrapperClass='mb-4' label='Contraseña' id='form2' type='password' value={clave} onChange={handleClaveChange} />

            <MDBBtn className="mb-4" onClick={handleLogin}>Ingresar</MDBBtn>

            <div className="text-center">
                <div className='d-flex justify-content-between mx-auto' style={{ width: '40%' }}>
                    Si no tienes contraseña,
                    Favor solicitala a soporte@rfid.cl
                </div>
            </div>
        </MDBContainer>
    );
};

export default Login;
